export function getClientId() {
    let clientId = sessionStorage.getItem('clientId');
    if (!clientId) {
        clientId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        sessionStorage.setItem('clientId', clientId);
    }
    return clientId;
}